import { useTranslation } from "react-i18next";
import { z } from "zod";

import { REFUSAL_REASON_MAX_LENGTH } from "../constants";

const useRefuseQuoteSchema = () => {
  const { t } = useTranslation(["quote-refusal"]);

  return z.object({
    reason: z
      .string()
      .trim()
      .max(
        REFUSAL_REASON_MAX_LENGTH,
        t("quote-refusal:refuse-reason-too-long", "At most {{max}} characters", {
          max: REFUSAL_REASON_MAX_LENGTH,
        }),
      ),
  });
};

export type RefuseQuoteFormValues = z.infer<ReturnType<typeof useRefuseQuoteSchema>>;

export default useRefuseQuoteSchema;
